import { Pipe, PipeTransform } from '@angular/core';
import { isNativeVideoStream } from '../directives/video-mount.directive';

/** Template form of {@link isNativeVideoStream}: picks `<canvas>` over `<video>`. */
@Pipe({ name: 'nativeVideo', standalone: true })
export class NativeVideoPipe implements PipeTransform {
  transform(stream: MediaStream | null | undefined): boolean {
    return isNativeVideoStream(stream);
  }
}
